import { render, staticRenderFns } from "./MonitorAprovacao.vue?vue&type=template&id=a31bdf20"
import script from "./MonitorAprovacao.vue?vue&type=script&lang=js"
export * from "./MonitorAprovacao.vue?vue&type=script&lang=js"
import style0 from "./MonitorAprovacao.vue?vue&type=style&index=0&id=a31bdf20&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports